module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-wrap",
    class: {
      'component-padded': _vm.base.padded, 'active': _vm.active
    }
  }, [_c('div', {
    staticClass: "current-active"
  }), _vm._v(" "), (_vm.base.title) ? _c('div', {
    staticClass: "component-header"
  }, [_c('div', {
    staticClass: "component-title",
    class: {
      'middle': _vm.config.type !== 'goods'
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.base.title))]), _vm._v(" "), (_vm.config.type !== 'goods') ? _c('countdown', {
    attrs: {
      "endTime": _vm.time,
      "endText": '活动已结束',
      "callback": function() {}
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.content) ? _c('div', {
          staticClass: "activity-timer"
        }, [_c('div', {
          staticClass: "time-box"
        }, [_vm._v(_vm._s(scope.day ? scope.day : '00'))]), _c('div', {
          staticClass: "dot"
        }, [_vm._v("天")]), _vm._v(" "), _c('div', {
          staticClass: "time-box"
        }, [_vm._v(_vm._s(scope.hour ? scope.hour : '00'))]), _c('div', {
          staticClass: "dot"
        }, [_vm._v("时")]), _vm._v(" "), _c('div', {
          staticClass: "time-box"
        }, [_vm._v(_vm._s(scope.min ? scope.min : '00'))]), _c('div', {
          staticClass: "dot"
        }, [_vm._v("分")]), _vm._v(" "), _c('div', {
          staticClass: "time-box"
        }, [_vm._v(_vm._s(scope.sec ? scope.sec : '00'))]), _c('div', {
          staticClass: "dot"
        }, [_vm._v("秒")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.text))])]) : _c('div', {
          staticClass: "activity-timer"
        }, [_vm._v(_vm._s(scope.content))])]
      }
    }], null, false, 506587879)
  }) : _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.base.subtitle))])], 1), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "component-body",
    class: _vm.config.type !== 'goods' ? 'seckill' : 'goods'
  }, [_c('div', {
    staticClass: "scroll-goods"
  }, _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "scroll-item"
    }, [(_vm.config.leaderboard) ? _c('div', {
      staticClass: "subscript"
    }, [_c('div', {
      staticClass: "subscript-text"
    }, [_vm._v("NO." + _vm._s(index + 1))]), _vm._v(" "), _c('img', {
      staticClass: "subscript-img",
      attrs: {
        "src": _vm.subscriptImg
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "thumbnail"
    }, [_c('img', {
      staticClass: "goods-img",
      attrs: {
        "src": _vm.wximageurl + item.imgUrl
      }
    })]), _vm._v(" "), (_vm.config.showPrice) ? _c('div', {
      staticClass: "caption"
    }, [(_vm.config.type !== 'goods') ? [_c('span', {
      staticClass: "cur"
    }, [_vm._v("¥")]), _vm._v(_vm._s(item.act_price ? item.act_price / 100 : '0.00') + " "), _c('span', {
      staticClass: "marketing-price"
    }, [_vm._v(_vm._s(item.price ? item.price / 100 : '0.00'))])] : [_c('span', {
      staticClass: "cur"
    }, [_vm._v("¥")]), _vm._v(_vm._s(item.price ? item.price / 100 : '0.00') + "\n          ")]], 2) : _vm._e()])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-more"
  }, [_c('div', {
    staticClass: "three-dot"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2aaf3319", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aaf3319"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/goods_scroll.vue
// module id = 2565
// module chunks = 0